export default (id, content) => {
  const el = document.getElementById(id)
  if (!el) {
    throw new Error('Element does not exist')
  }
  el.innerHTML = content
}
